import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=0e5dd7b5&"
import script from "./Enquiries.vue?vue&type=script&lang=js&"
export * from "./Enquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTable,QToggle,QSelect,QChip,QItem,QInput,QIcon,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTable,QToggle,QSelect,QChip,QItem,QInput,QIcon,QTd})
